import { services } from "../../../../constants/services";
import { getByQuery } from "../../../../utils/api";
export interface IParamasGetEnvironment {
  apiServiceId?: string,
}
export const GetEnvironmetByApiService = async (params: IParamasGetEnvironment) => {
  const response: any = await getByQuery<any>(`${services["environment-variables"]}/by-api-service`,params);
  return response?.data;
};